export const externalRedirect = (url: string) => {
    window.location.href = url;
};